import { createAction } from 'redux-actions';

export const receiveRankingHistory = createAction('api/RECEIVED_RANKING_HISTORY');
